<template>
  <div class="service-container">
    <img src="./../../asset/wx-work.png" alt="企业微信logo" width="150" class="service-logo">
    <van-form>

      <van-field v-model="corpInfo.name" label="企业名称" right-icon="arrow-down" size="large" readonly clickable @click="showPicker = true"/>
      <van-field v-model="corpInfo.corpId" label="企业ID" placeholder="请输入企业ID" size="large" :rules="[{ required: true, message: '请填写企业ID' }]"/>
      <van-field v-model="corpInfo.agentId" label="应用ID" placeholder="请输入应用ID" size="large" :rules="[{ required: true, message: '请填写应用ID' }]" />
      <van-field v-model="corpInfo.secret" label="密钥" placeholder="请输入密钥" size="large" :rules="[{ required: true, message: '请填写密钥' }]" />
      <van-field v-model="corpInfo.subdomain" label="域名前缀" placeholder="例：lenovo" size="large" center :rules="[{ required: true, message: '请填写域名前缀' }]">
        <template #extra>
          .{{ host }}
        </template>
      </van-field>
      <van-field v-model="file.name" label="验证文件" placeholder="例：WW_verify_AyJVJK8BHRSecndw.txt" size="large" center readonly :rules="[{ required: true, message: '请上传可信域名验证文件' }]">
        <template #button>
          <van-uploader :before-read="beforeRead" :after-read="afterRead" accept="text/plain">
            <van-button icon="column" type="primary" size="small">上传</van-button>
          </van-uploader>
        </template>
      </van-field>

      <div class="service-btn">
        <van-button plain round block type="primary" @click="onSubmit">提交</van-button>
      </div>
    </van-form>



    <!--&lt;!&ndash; 居中 &ndash;&gt;
    <van-row type="flex" justify="center">
      <van-col span="16">
        <div id="step">
          <van-steps :active="active" active-icon="success" active-color="#38f" inactive-icon="arrow">
            <van-step v-for="step in steps" >{{step}}</van-step>
          </van-steps>
        </div>
      </van-col>
    </van-row>

    &lt;!&ndash; 居中 &ndash;&gt;
    <van-row type="flex" justify="center">
      <van-col span="18">
        &lt;!&ndash;第一步 创建应用&ndash;&gt;
        <transition name="van-fade">
        <div v-show="active == 0">
          <div class="service-tip">
            <p>1. 请管理员登录企业微信后台 <br>&nbsp;&nbsp;&nbsp;  <a href="https://work.weixin.qq.com/wework_admin/loginpage_wx" target="_blank">https://work.weixin.qq.com/wework_admin/loginpage_wx</a></p>
            <p>2. 选择 <span class="service-menu">应用管理</span>，点击<span class="service-menu">创建应用</span></p>
            <p>3. 设置 logo 和 可见范围</p>
          </div>

          <van-grid :border="false" :column-num="2">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/create1.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/create2.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

        &lt;!&ndash;第二步 填写企业ID&ndash;&gt;
        <transition name="van-fade">
        <div v-show="active == 1">
          <div class="service-tip">
            <p>1. 选择 <span class="service-menu">我的企业</span></p>
            <p>2. 在页面最底端找到 <span class="service-menu">企业ID</span></p>
            <p>3. 请复制 <span class="service-menu">企业ID</span>，填入下方输入框中</p>
            <van-cell-group><van-field v-model="corpId" label="企业ID" placeholder="请输入企业ID" size="large" :readonly="paramSet" /></van-cell-group>
          </div>

          <div class="service-one">
            <van-image src="http://zone.histone.wang/img/corpid.png" />
          </div>
        </div>
        </transition>

        &lt;!&ndash;第三步 填写应用ID&ndash;&gt;
        <transition name="van-fade">
        <div v-show="active == 2">
          <div class="service-tip">
            <p>1. 选择 <span class="service-menu">应用管理</span>，找到步骤一创建的应用</p>
            <p>2. 点击应用图标查看应用详情</p>
            <p>3. 请复制 <span class="service-menu">应用ID（AgentId）</span> 和 <span class="service-menu">密钥（Secret）</span>，分别填入下方输入框中</p>
            <van-cell-group>
              <van-field label="应用ID" v-model="agentId" placeholder="请输入应用ID" size="large" :readonly="paramSet" />
              <van-field label="密钥" v-model="secret" placeholder="请输入密钥" size="large" :readonly="paramSet" />
            </van-cell-group>
          </div>

          <div class="service-one">
            <van-image src="http://zone.histone.wang/img/secret.png" />
          </div>
        </div>
        </transition>

        &lt;!&ndash;第四步 上传文件&ndash;&gt;
        <transition name="van-fade">
        <div v-show="active == 3">
          <div class="service-tip">
            <p>1. 在应用详情页的最底部，找到并点击 <span class="service-menu">设置可信域名</span></p>
            <p>2. 点击弹窗中的 <span class="service-menu">申请校验域名</span></p>
            <p>3. 点击<span class="service-menu">下载文件</span></p>
            <p>4. 请点击下方按钮，上传刚才下载的TXT文件</p>
            <van-uploader  :before-read="beforeRead" :after-read="afterRead" accept="text/plain">
              <van-button icon="column" type="primary">上传文件</van-button>
            </van-uploader>
          </div>

          <van-grid :border="false" :column-num="3">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain1.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain2.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain3.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

        &lt;!&ndash;第五步 回填域名&ndash;&gt;
        <transition name="van-fade">
        <div v-show="active == 4">
          <div class="service-tip">
            <p>1. 请确保完成文件上传，否则此步骤会失败</p>
            <p>2. 在域名输入框中输入 <span class="service-menu">{{host}}</span></p>
            <p>3. 勾选 <span class="service-menu">已上传域名归属校验文件</span>，点击确定</p>
            <p>4. 成功后，链接变为 <span class="service-menu">已启用</span></p>
          </div>

          <van-grid :border="false" :column-num="2">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain4.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain5.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

      </van-col>
    </van-row>


    <div class="service-btn">
      <van-button plain type="primary" v-show="active!=0" @click="active -= 1">上一步</van-button>
      <van-button plain type="primary" @click="next">{{active == steps.length-1 ? '完成' : '下一步'}}</van-button>
    </div>-->
    <van-popup v-model="showPicker">
      <van-cell-group class="service-corp-list">
        <van-cell :title="item.name" class="service-corp-list-item" v-for="item in corpList" :key="item.id" clickable @click="selectCorp(item)"/>
      </van-cell-group>
    </van-popup>

    <router-link to="/service/help" class="service-help"><img src="../../asset/help.png" alt="帮助" title="获取帮助"> </router-link>
  </div>


</template>

<script>
import { Image, Button, Field, Form, Cell, CellGroup, Uploader, Popup, Dialog } from 'vant';

export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup
  },

  data() {
    return {
      corpList: '',
      corpInfo: {
        id: '',
        name: '',
        corpId: '',
        agentId: '',
        secret: '',
        subdomain: ''
      },
      file: '',
      host: 'cp.asset.mspcloud.top',
      showPicker: false
    };
  },
  methods: {
    selectCorp(item) {
      this.corpInfo.id = item.id;
      this.corpInfo.name = item.name;
      this.showPicker = false;
    },
    onSubmit() {
      let params = new FormData();
      params.append('file', this.file);
      params.append('cpStr', JSON.stringify(this.corpInfo));
      params.append('host', this.host);
      this.$axios.post('wx/service', params, {
          'Content-Type': 'multipart/form-data'
        }).then(()=>{
          Dialog({ message: '提交成功\n请提醒企业微信管理员验证可信域名\n'+this.corpInfo.subdomain+'.'+this.host})
        }).catch((res) => {
          Dialog({ message: '提交失败\n'+ res })
        })
    },

    beforeRead(file) {
      if (file.type !== 'text/plain') {
        Dialog({ message: '请上传正确类型的文件' });
        return false;
      }
      if (!file.name.startsWith('WW_verify')) {
        Dialog({ message: '上传文件内容不正确'});
        return false;
      }

      return true;
    },

    afterRead(file) {
      this.file = file.file;
    }
  },
  created() {
    this.$axios.get('wx/cp').then(res=> this.corpList = res)
  }
};
</script>

<style lang="less">
.service {
  &-container {
    width: 500px;
    margin: 100px auto 0;
    padding: 50px 100px;
    text-align: center;
    border: 1px solid #88C1FA;
    border-radius: 20px;
  }
  &-logo {
    margin-bottom: 70px;
  }
  &-corp-list {
    width: 300px;
    padding: 50px;
    &-item:hover {
      background-color: #f5f5f5;
    }
  }
  &-help {
    position: fixed;
    right: 200px;
    top: 100px;
  }

  &-btn {
    margin-top: 80px;
    padding: 0 200px;
  }
}
</style>
